<!-- @format -->

<template>
	<img v-if="logo" :src="logo" class="pcp-header-logo" @click="handleClick" />
</template>

<script setup lang="ts">
	import {
		useGlobalStoreWithOut,
		getFileUrlById,
		getFrontEndConfigItemByCodeAndItemCode,
		getEnvUrlByUrl,
	} from '@power/runtime-vue3';

	const globalStore = useGlobalStoreWithOut();

	const logo = computed(() => {
		const logoUrl = getFrontEndConfigItemByCodeAndItemCode(
			globalStore.frontEndConfig,
			'login',
			'headerLogo',
		)?.itemValue;
		return logoUrl && getFileUrlById(logoUrl);
	});
	const handleClick = () => {
		const url = getEnvUrlByUrl('/');
		if (window.parent === window.self) {
			window.location.href = url;
		} else {
			window.parent.location.href = url;
		}
	};
</script>

<style lang="scss" scoped>
	.pcp-header-logo {
		height: 28px;
		width: auto;
		cursor: pointer;
	}
</style>
